const ITEM_NAME = 'logIndex';

/**
 * @name getLogIndex
 * @function
 * @description Marks a section of block history as viewed so the app will stop viewing it
 * @param {array} offers 
 */
export const getLogIndex = () => {
    return Number( localStorage.getItem( ITEM_NAME ) );
}

/**
 * @name setLogIndex
 * @function
 * @description Marks a section of block history as viewed so the app will stop viewing it
 * @param {array} offers 
 */
export const setLogIndex = lastBlock => {
    localStorage.setItem( ITEM_NAME, lastBlock );
}